import { render, staticRenderFns } from "./EditNewRelicModal.vue?vue&type=template&id=2f62175a&"
import script from "./EditNewRelicModal.vue?vue&type=script&lang=js&"
export * from "./EditNewRelicModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports